<div class="bgf-page workspace-page bgf-games">
    <section class="workspace-shell">
        <div class="workspace-shell__header">
            <div class="workspace-title-block">
                <span class="workspace-title-block__icon">
                    <i class="fa-solid fa-dice"></i>
                </span>
                <div class="workspace-title-block__copy">
                    <h1>Játékok</h1>
                    <p>A rendelés- és riportnézettel egységesített játék törzsadat lista.</p>
                </div>
            </div>

            <div class="workspace-shell__actions">
                <span class="workspace-meta-pill">
                    <i class="fa-solid fa-list"></i>
                    {{ totalGames | number:'1.0-0' }} játék
                </span>
                <button class="button is-primary workspace-button" (click)="addNewGame()">
                    <span class="icon">
                        <i class="fa-solid fa-plus"></i>
                    </span>
                    <span>Új játék</span>
                </button>
            </div>
        </div>

        <div class="workspace-surface">
            <div class="workspace-surface__head">
                <div class="workspace-surface__copy">
                    <h2>Játéklista</h2>
                    <p>Gyors áttekintés a játékok neveiről, SKU előtagjairól és publikus linkjeiről.</p>
                </div>
            </div>

            <div class="workspace-table-wrap" [ngClass]="{'bgf-loading bgf-loading--color': fetching}">
                <table class="workspace-table" mat-table matSort [dataSource]="dataSource">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let element">{{element.id}}</td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Játék neve</th>
              <td mat-cell *matCellDef="let element">{{element.name}}</td>
            </ng-container>
            <ng-container matColumnDef="prefix">
              <th mat-header-cell *matHeaderCellDef>SKU előtag</th>
              <td mat-cell *matCellDef="let element">{{element.prefix}}</td>
            </ng-container>
            <ng-container matColumnDef="url">
              <th mat-header-cell *matHeaderCellDef>URL</th>
              <td mat-cell *matCellDef="let element">
                <a class="game-link workspace-link" target="_blank" [href]="element.url">{{element.url}}</a>
              </td>
            </ng-container>
            <ng-container matColumnDef="edit">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <span class="workspace-action-icon" (click)="editGame(element)">
                    <i class="fa-solid fa-gear"></i>
                </span>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <div class="workspace-empty-state" *ngIf="!fetching && !dataSource.data.length">
                    <i class="fa-solid fa-dice"></i>
                    <h3>Nincs megjeleníthető játék</h3>
                    <p>Adj hozzá új játékot, vagy lapozz vissza egy korábbi oldalra.</p>
                </div>
            </div>

            <div class="workspace-pagination">
                <mat-paginator
                  [length]="totalGames"
                  [pageSizeOptions]="pageSizeOptions"
                  [pageSize]="pageSize"
                  [pageIndex]="pageIndex"
                  (page)="onPageChange($event)"
                  showFirstLastButtons
                  aria-label="Játék lista lapozás">
                </mat-paginator>
            </div>
        </div>
    </section>
</div>
